import React from 'react'
import classNames from 'classnames'
import { isEmpty } from 'lodash'

import { Pill } from '@/components/pills/Pill'

import { formatVersionDate } from '../drawerHelpers'

// Newest-first list of prompt versions. Each row shows date + author +
// summary, with a green "Current" pill on the active (newest) version. Click a
// row to peek that version; the peeked (non-current) row gets a tinted
// background. `latest` is resolved by the parent from the same versions list.
const PromptVersionList = ({ versions, latest, activeVersion, onPeek }) => {
  if (isEmpty(versions)) {
    return (
      <div className="voice-agents__version-empty" data-testid="version-list-empty">
        No saved versions yet.
      </div>
    )
  }

  // BE returns newest-first per pe-api-reference.md; fall back to a sort if
  // the data ever arrives in a different order.
  const ordered = [...versions].sort((a, b) => (b.version || 0) - (a.version || 0))

  return (
    <div className="voice-agents__version-list" data-testid="version-list">
      {ordered.map((entry) => {
        const isLatest = latest && entry.version === latest.version
        const isViewing = activeVersion && entry.version === activeVersion.version

        return (
          <button
            type="button"
            key={entry.version}
            className={classNames('voice-agents__version-row', {
              'voice-agents__version-row--viewing': isViewing && !isLatest,
            })}
            onClick={() => onPeek(entry.version)}
            data-testid={`version-row-${entry.version}`}
            data-version={entry.version}
          >
            <div className="voice-agents__version-row-date">
              {formatVersionDate(entry.createdAt)}
            </div>
            <div className="voice-agents__version-row-body">
              <div className="voice-agents__version-row-author">
                by user {entry.createdBy || '—'}
              </div>
              <div className="voice-agents__version-row-summary">
                {entry.summary || '(no summary)'}
              </div>
            </div>
            {/* The pill cell always reserves its width; hidden (opacity 0) on
                non-latest rows so the columns stay aligned across the list. */}
            <div
              className={classNames('voice-agents__version-row-badges', {
                'voice-agents__version-row-badges--hidden': !isLatest,
              })}
            >
              <Pill success xs data-testid={`version-badge-latest-${entry.version}`}>
                Current
              </Pill>
            </div>
          </button>
        )
      })}
    </div>
  )
}

export default PromptVersionList
